<script setup lang="ts">
const route = useRoute();

const navItems = [
  {
    name: '',
    icon: 'mobile-menu-bar/homepage',
    path: '/',
  },
  {
    name: 'Slots',
    icon: 'mobile-menu-bar/slots',
    path: '/games/category/all?initialCategory=slots',
  },
  {
    name: 'Cassino ao vivo',
    icon: 'mobile-menu-bar/cassino',
    path: '/games/category/all?initialCategory=jogos-ao-vivo',
  },
  {
    name: 'Esporte',
    icon: 'mobile-menu-bar/esporte',
    path: '/sports',
  },
];

const isActive = (path: string) => {
  if (path.includes('?')) {
    return route.fullPath === path;
  }

  return route.path === path && !route.query.tab;
};
</script>

<template>
  <nav :class="$style.navButtons">
    <NuxtLink
      v-for="item in navItems"
      :key="item.path"
      :class="[
        $style.navButton,
        { [$style.active]: isActive(item.path), [$style.iconOnly]: !item.name },
      ]"
      :to="item.path"
    >
      <NuxtIcon
        class="text-[18px]"
        :filled="false"
        :name="item.icon"
      />
      <span
        v-if="item.name"
        :class="$style.label"
        >{{ item.name }}</span
      >
    </NuxtLink>
  </nav>
</template>

<style module lang="postcss">
.navButtons {
  @apply flex items-center gap-2;
}

.navButton {
  @apply flex items-center gap-2 px-3 py-2 text-white text-[13px] font-semibold transition-all duration-200 no-underline;
  @apply hover:text-white hover:bg-white/5;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 38px;
  min-height: 38px;

  &.active {
    @apply text-white;
    border-radius: 6px;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.1);
  }

  &.iconOnly {
    @apply justify-center;
    width: 38px;
    min-width: 38px;
    padding: 0;
  }
}

.icon {
  @apply text-[20px];
}

.label {
  @apply hidden lg:inline font-medium;

  @media (min-width: 1024px) and (max-width: 1180px) {
    @apply hidden;
  }
}
</style>
